import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-aiming"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M17.5559 11.9996C17.5559 15.0679 15.0686 17.5552 12.0004 17.5552C8.93213 17.5552 6.44482 15.0679 6.44482 11.9996C6.44482 8.9314 8.93213 6.44409 12.0004 6.44409C15.0686 6.44409 17.5559 8.9314 17.5559 11.9996Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M17.5557 11.9997C17.5557 15.0679 15.0684 17.5552 12.0002 17.5552M17.5557 11.9997C17.5557 8.93143 15.0684 6.44412 12.0002 6.44412M17.5557 11.9997H18.6668M12.0002 17.5552C8.93191 17.5552 6.44461 15.0679 6.44461 11.9997M12.0002 17.5552V18.6663M6.44461 11.9997C6.44461 8.93143 8.93191 6.44412 12.0002 6.44412M6.44461 11.9997H5.3335M12.0002 6.44412V5.33301M13.1111 11.9998C13.1111 12.6134 12.6137 13.1109 12 13.1109C11.3864 13.1109 10.8889 12.6134 10.8889 11.9998C10.8889 11.3861 11.3864 10.8887 12 10.8887C12.6137 10.8887 13.1111 11.3861 13.1111 11.9998Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapAiming = Vue.extend<IconProps>({
  name: 'MapAimingIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'map-aiming',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MapAiming;
